export default __webpack_public_path__ + "static/media/icon-nav.8240d2c0.svg";